<template>
  <v-stepper-content step="3">
    <h3 class="mb-4">Datos del Plan</h3>
  <v-checkbox
    v-model="mismoQueContratante"
    label="El titular es el mismo que el contratante"
    class="mb-4"
  />
    <v-form ref="formContratante" v-model="valid" lazy-validation>
      <v-row>
        <v-col cols="12" md="4">
{{ this.planNombre }}
        </v-col>

        <v-col cols="12" md="4">
          <v-text-field v-model="contratante.apellidoPaterno" label="Apellido paterno" outlined dense clearable
            :rules="[rules.ruleRequired]"
            @input="contratante.apellidoPaterno = toUpperCaseGeneral(contratante.apellidoPaterno)" />
        </v-col>

        <v-col cols="12" md="4">
          <v-text-field v-model="contratante.apellidoMaterno" label="Apellido materno" outlined dense clearable
            :rules="[rules.ruleRequired]"
            @input="contratante.apellidoMaterno = toUpperCaseGeneral(contratante.apellidoMaterno)" />
        </v-col>

        <v-col cols="12" md="4">
          <v-text-field label="Teléfono" outlined dense clearable v-model="contratante.telefono" prepend-inner-icon="mdi-phone"
            v-mask="'###-###-####'" :rules="[rules.ruleRequired, rules.ruleTelephone]" />
        </v-col>

        <v-col cols="12" md="4">
          <v-text-field label="Correo electrónico" outlined dense clearable v-model="contratante.email"
            prepend-inner-icon="mdi-email" :rules="[rules.ruleRequired, rules.ruleEmail]" />
        </v-col>

        <v-col cols="12" md="2">
          <v-text-field v-model="contratante.fechaNacimiento" label="Fecha de nacimiento" outlined dense type="date"
            :rules="[rules.ruleRequired]" />
        </v-col>

        <v-col cols="12" md="2">
          <v-select v-model="contratante.sexo" :items="['FEMENINO ', 'MASCULINO']" :rules="[rules.ruleRequired]"
            label="Sexo" outlined dense />
        </v-col>

        <v-col cols="12" md="4">
          <v-text-field v-model="contratante.curp" label="CURP" :rules="[rules.ruleRequired, rules.ruleCURP]" clearable
            @input="contratante.curp = toUpperCaseGeneral(contratante.curp)" outlined dense />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field v-model="contratante.rfc" label="RFC" :rules="[rules.ruleRequired, rules.ruleRFC]" clearable
            @input="contratante.rfc = toUpperCaseGeneral(contratante.rfc)" outlined dense />
        </v-col>
      </v-row>
    <DireccionForm ref="direccionContratante" v-model="contratante.direccion" title="Dirección del contratante" />

      <v-row>
        <v-col cols="12" class="d-flex justify-end">
          <v-btn color="primary" class="mt-4" @click="nextStep">
            Siguiente
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-stepper-content>
</template>

<script>
import upperCase from '@/mixins/upperCase';
import DireccionForm from '../Forms/DireccionForm.vue';


export default {
  props: ["goNext"],
  mixins: [upperCase],
  components: {
    DireccionForm
  },
  data() {
    return {
      mismoQueContratante: false,
      planNombre:'',
      valid: false,
      contratante: {
        nombre: "karen",
        apellidoPaterno: "castillo",
        apellidoMaterno: "rodriguez",
        telefono: "4446638189",
        email: "karen@gmail.com",
        fechaNacimiento: "1993-12-12",
        sexo: "",
        curp: "CARK931229MSPSDR00",
        rfc: "CARK931229DZ2",
        direction: {}
      }
    };
  },
  mounted(){
     this.getPlan()
  },
  computed: {
    rules() {
      return this.$rules;
    }
  },
  methods: {
    nextStep() {
      if (this.$refs.formContratante.validate() && this.$refs.direccionContratante.validate()) {
        this.$emit("saveContratante", this.contratante); // 🔥 envías datos al padre
        this.goNext();
      }
    },
    getPlan(){
      this.$http.get(`solicitud/plan?idplan=${4}`)
    .then(response => {
        if (response.status === 200) {
            this.planNombre = response.data
            console.log(this.planNombre)
        }
    }).catch(() => {
    });
    }
  }
};
</script>
